import { CenteredContainer, PortalButton, GuestDayList, SVGIcon } from '@custom-components';
import { PropTypes } from 'prop-types';
import React from 'react';
import { STable } from '@/customComponents/BuildingBlocks/SortableTable/SortableTable';

export class BookingList extends React.Component {
  static propTypes = {
    bookings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectDay: PropTypes.func,
    currentBooking: PropTypes.shape({}),
    expandBooking: PropTypes.func.isRequired,
    onSelectDay: PropTypes.func,
    selectable: PropTypes.bool
  };

  static defaultProps = {
    onSelectDay: () => false,
    selectDay: () => false,
    currentBooking: null,
    selectable: false
  };

  rowMap = {
    bookingId: {
      id: 'bookingId',
      label: 'Booking ID'
    },
    propertyName: {
      id: 'propertyName',
      label: 'Property Name'
    },
    payingCustomer: {
      id: 'payingCustomer',
      label: 'Paying Customer'
    },
    guestDays: {
      id: 'guestDays',
      label: 'Guest Days'
    },
    bookingDates: {
      id: 'bookingDates',
      label: 'Booking Dates'
    },
    editBooking: {
      id: 'editBooking'
    },
    expand: {
      id: 'expand'
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedDayIds: [],
      selectedDays: [],
      selectedBookings: [],
      isExpanded: false
    };
  }

  selectBooking = (booking) => {
    const { selectedBookings, selectedDayIds } = this.state;
    let { selectedDays } = this.state;

    if (selectedBookings.indexOf(booking.bookingNumber) === -1) {
      selectedBookings.push(booking.bookingNumber);
      selectedDays = selectedDays.concat(booking.guestDays.filter((day) => selectedDayIds.indexOf(day.id) === -1));
    } else {
      selectedBookings.splice(selectedBookings.indexOf(booking.bookingNumber), 1);
      selectedDays = selectedDays.filter((day) => day.bookingId !== booking.bookingNumber);
    }

    this.setSelectedDays(selectedDays, selectedBookings);
  };

  selectGuestDay = (day) => {
    const { selectedBookings, selectedDayIds } = this.state;
    const { bookings } = this.props;
    let { selectedDays } = this.state;

    const parentBooking = bookings.find((booking) => booking.bookingNumber === day.bookingId);

    if (selectedDayIds.indexOf(day.id) !== -1) {
      selectedDays = selectedDays.filter((element) => element.id !== day.id);
      if (selectedBookings.indexOf(day.bookingId) !== -1) {
        selectedBookings.splice(selectedBookings.indexOf(day.bookingId), 1);
      }
    } else {
      selectedDays.push(day);
      if (
        parentBooking &&
        selectedDays.filter((element) => element.bookingId === day.bookingId).length === parentBooking.guestDays.length
      ) {
        selectedBookings.push(day.bookingId);
      }
    }

    this.setSelectedDays(selectedDays, selectedBookings);
  };

  createRow = (booking) => {
    const { selectedBookings, selectedDayIds, isExpanded } = this.state;
    const { selectDay, currentBooking, selectable } = this.props;

    return {
      id: booking.bookingNumber,
      selected: selectedBookings.indexOf(booking.bookingNumber) !== -1,
      onSelect: () => this.selectBooking(booking),
      columns: [
        {
          value: booking.bookingNumber,
          columnId: this.rowMap.bookingId.id,
          label: STable.columnLabel(this.rowMap.bookingId.label, booking.bookingNumber)
        },
        {
          value: booking.property.name,
          columnId: this.rowMap.propertyName.id,
          label: STable.columnLabel(this.rowMap.propertyName.label, booking.property.name)
        },
        {
          value: booking.customer.name,
          columnId: this.rowMap.payingCustomer.id,
          label: STable.columnLabel(this.rowMap.payingCustomer.label, booking.customer.name)
        },
        {
          value: booking.guestDays.length,
          columnId: this.rowMap.guestDays.id,
          label: STable.columnLabel(this.rowMap.guestDays.label, booking.guestDays.length)
        },
        {
          value: booking.startDate,
          columnId: this.rowMap.bookingDates.id,
          label: STable.columnLabel(
            this.rowMap.bookingDates.label,
            <div>
              {booking.startDate} - {booking.endDate}
            </div>
          )
        },
        {
          value: booking.bookingNumber,
          columnId: this.rowMap.editBooking.bookingNumber,
          label: (
            <PortalButton
              route="BookingDetails"
              params={{ bookingNumber: booking.bookingNumber }}
              buttonTheme="secondary"
              fullWidth
            >
              Open Booking
            </PortalButton>
          )
        },
        {
          value: booking.bookingNumber,
          columnId: this.rowMap.expand.id,
          label: (
            <CenteredContainer style={{ height: '100%' }}>
              <PortalButton buttonTheme="blank" onClick={() => this.expandBookingChildren(booking.bookingNumber)}>
                <SVGIcon
                  selectedIcon="arrow"
                  rotate={
                    isExpanded && currentBooking && currentBooking.bookingNumber === booking.bookingNumber ? 180 : 0
                  }
                />
              </PortalButton>
            </CenteredContainer>
          )
        }
      ],
      auxilaryComponent:
        isExpanded && currentBooking && currentBooking.bookingNumber === booking.bookingNumber ? (
          <GuestDayList
            days={booking.guestDays}
            selectedDays={selectedDayIds}
            selectDay={this.selectGuestDay}
            openGuestDay={selectDay}
            hideHeaderCheckbox
            selectable={selectable}
          />
        ) : undefined
    };
  };

  expandBookingChildren = (id) => {
    const { currentBooking, expandBooking } = this.props;
    const { isExpanded } = this.state;

    if (isExpanded && currentBooking && currentBooking.bookingNumber === id) {
      this.setState({ isExpanded: false });
    } else {
      expandBooking(id);
      this.setState({ isExpanded: true });
    }
  };

  setSelectedDays = (selectedDays, selectedBookings) => {
    const { onSelectDay } = this.props;

    onSelectDay(selectedDays, selectedBookings);

    this.setState({
      selectedBookings,
      selectedDays,
      selectedDayIds: selectedDays.map((day) => day.id)
    });
  };

  render() {
    const { bookings, selectable } = this.props;

    return (
      <STable
        showHeader={false}
        columns={Object.values(this.rowMap)}
        defaultSort={this.rowMap.bookingId.id}
        rows={bookings.map((booking) => this.createRow(booking))}
        selectable={selectable}
        pagination
      />
    );
  }
}
